import { Box, Typography } from "@mui/material";
import React from "react";
import TransferList from "./TransferList";
import { useSelector } from "react-redux";

export default function SkuPgSearchResult() {
	const setupState = useSelector((store) => store.scenarioSetupNew);
	const { productGroups, selectedPGs } = setupState;
	return (
		<Box
			sx={{
				mt: 1,
				p:2,
				borderLeft: 1,
				borderColor: "#c6c6c6"

			}}
		>


			<Box container sx={{ mt: 1, justifyContent: "space-between"}}>
				<TransferList sx={{justifyContent: "space-between",}}
					leftList={productGroups}
					rightList={selectedPGs}
					leftState={"productGroups"}
					rightState={"selectedPGs"}
					isCustomer = {false}
				/>
			</Box>
		</Box>
	);
}
